export default __webpack_public_path__ + "resources/images/databox-header-mobile.png";